module.exports = __webpack_public_path__ + "img/32.545e729c.png";